import { render, staticRenderFns } from "./NewLeave.vue?vue&type=template&id=53c7cccc&"
import script from "./NewLeave.vue?vue&type=script&lang=js&"
export * from "./NewLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports